export default __webpack_public_path__ + "static/media/blueMarker.0d79821b.svg";